import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { badgeRoleOptions } from 'src/features/userManagement/utils/constants';
import { Badge } from 'src/registry/ui/Badge';
import { cn } from 'src/utils/shadcn';

import type { CellContext } from '@tanstack/react-table';
import type { BadgeOptions } from 'src/registry/types/badges';

interface CellBadgeProps<TData, TValue> extends CellContext<TData, TValue> {
    badgeOptions?: BadgeOptions;
}

// Role cell which is reading from all roles as the currently available records could have a role
// which could be excluded from the parking. This would lead to incomplete translations.
export function RoleCellBadge<TData, TValue>({ cell }: CellBadgeProps<TData, TValue>) {
    const { formatMessage } = useIntl();
    const option = badgeRoleOptions[cell.getValue() as string];

    const { iconColor, ...colors } = option?.color ?? { iconColor: undefined };

    return (
        <Badge theme={option?.theme || 'gray'} style={colors}>
            {option?.icon && (
                <FontAwesomeIcon
                    icon={option.icon}
                    className={cn('z-0', !iconColor && !option.theme && 'opacity-50')}
                    style={{ color: iconColor }}
                    size={option.iconSize}
                />
            )}
            {option?.label ? formatMessage(option.label) : String(cell.renderValue())}
        </Badge>
    );
}
